module.exports = __webpack_public_path__ + "static/media/M62ws.69eecbfb.pdf";